import Api from '../../../common/services/api';

export default (organisationId, channelId) => async () => {
  return Api.post(`/v1/organisations/${organisationId}/channels/${channelId}/cancel-access-request`);
};
